import Image from 'next/image'
import { useRouter } from 'next/router'
import { LeftAction } from 'types'

interface Props {
  action?: LeftAction
  onClick?: () => void
}

/**
 * Back link for nav bars.
 * Uses navigate to previous URL as a click handler
 */
export const NavBackButton = ({ action = 'back', onClick }: Props) => {
  const router = useRouter()
  const handleBack = onClick ? onClick : () => router.back()

  return (
    <a className='cursor-pointer flex' onClick={handleBack}>
      <Image
        src={action === 'back' ? '/icons/ic-back.svg' : '/icons/ic-close.svg'}
        width={35}
        height={35}
        alt={action === 'back' ? 'Back' : 'Close'}
      />
    </a>
  )
}
